import { FormField } from 'global/components/Form'
import { Fragment, useEffect } from 'react'
import { useFormContext } from 'react-hook-form'
import { SelectColaboradores } from 'templates/Avaliacao/atoms/forms/SelectColaboradores'
import { SelectFunction } from 'templates/Avaliacao/atoms/forms/SelectFuncoes'

import Grid from '@/global/components/ui/Grid'
import { BrasilApiCnpj } from '@/types'
import { cpfValido, isCaepfValido, isCnpjValido } from '@acme/common'
import axios from 'axios'
import { AutocompleteSegmento } from 'templates/Cadastro/Empresas/atoms/forms/DadosCadastrais/AutocompleteSegmento'
import { SelectCategorias } from './SelectCategorias'

export function NovoClienteForm() {
    const { watch, clearErrors, setValue, setError } = useFormContext()

    const representante = watch('categoriaId') === 7

    const document = watch('cnpj')

    useEffect(() => {
        let timerDigitacaoDocumento: ReturnType<typeof setTimeout>
        const doc =
            document
                ?.toUpperCase()
                .replace(/[^A-Z0-9]/g, '')
                .slice(0, 14) || ''

        if (cpfValido(doc)) {
            clearErrors('cnpj')
            setValue(
                'cnpj',
                doc.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4'),
            )
        } else if (isCnpjValido(doc)) {
            axios
                .get<BrasilApiCnpj>(
                    `https://brasilapi.com.br/api/cnpj/v1/${doc}`,
                )
                .then(async ({ data }) => {
                    console.log(data)
                    if (!watch('razaoSocial')) {
                        setValue('razaoSocial', data.razao_social)
                    }
                    if (!watch('nomeFantasia')) {
                        setValue('nomeFantasia', data.nome_fantasia)
                    }
                    if (!watch('uf')) {
                        setValue('uf', data.uf)
                    }
                    if (!watch('cep')) {
                        setValue('cep', data.cep)
                    }
                    if (!watch('Cidade.cidade')) {
                        setValue('Cidade', {
                            cidade: data.municipio,
                            uf: data.uf,
                            ibge: data.codigo_municipio_ibge,
                        })
                    }
                    if (!watch('bairro')) {
                        setValue('bairro', data.bairro)
                    }
                    if (!watch('endereco')) {
                        setValue('endereco', data.logradouro)
                    }
                    if (!watch('numero')) {
                        setValue('numero', data.numero)
                    }
                    if (!watch('telefoneResponsavel')) {
                        setValue(
                            'telefoneResponsavel',
                            data.ddd_telefone_1?.toString(),
                        )
                    }
                    if (!watch('telefone')) {
                        setValue('telefone', data.ddd_telefone_2?.toString())
                    }
                    if (!watch('nomeResponsavel')) {
                        setValue(
                            'nomeResponsavel',
                            data.qsa[0]?.nome_socio ?? '',
                        )
                    }
                })
                .catch(e => {
                    console.error('Erro ao buscar dados do CNPJ:', e)
                })

            clearErrors('cnpj')
            setValue(
                'cnpj',
                doc.replace(
                    /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
                    '$1.$2.$3/$4-$5',
                ),
            )
        } else if (isCaepfValido(doc)) {
            clearErrors('cnpj')
            setValue(
                'cnpj',
                doc.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4'),
            )
        } else {
            if (doc.length < 11 || (doc.length > 11 && doc.length < 14))
                clearErrors('cnpj')

            timerDigitacaoDocumento = setTimeout(() => {
                if (doc.length === 11) {
                    setError('cnpj', {
                        type: 'validate',
                        message: 'CPF inválido',
                    })
                } else if (doc.length === 14) {
                    setValue(
                        'cnpj',
                        doc.replace(
                            /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
                            '$1.$2.$3/$4-$5',
                        ),
                    )
                    setError('cnpj', {
                        type: 'validate',
                        message: 'CNPJ ou CAEPF inválido',
                    })
                }
            }, 500)
        }

        return () => clearTimeout(timerDigitacaoDocumento)
    }, [document])

    return (
        <Grid container rowSpacing={2} columnSpacing={3}>
            <Grid item xs={12}>
                <SelectCategorias required />
            </Grid>

            <Grid item xs={12}>
                <FormField
                    name="cnpj"
                    label="Documento (CPF, CNPJ ou CAEPF)"
                    required
                />
            </Grid>

            {!representante && (
                <Grid item xs={12}>
                    <FormField
                        name="nomeFantasia"
                        label="Nome da empresa"
                        required
                    />
                </Grid>
            )}

            <Grid item xs={12} sm={6}>
                <FormField
                    name="nomeResponsavel"
                    label="Nome completo"
                    required
                />
            </Grid>

            <Grid item xs={12} sm={6}>
                <FormField
                    name="emailResponsavel"
                    label="Email para contato"
                    required
                />
            </Grid>

            <Grid item xs={12} sm={6}>
                <FormField
                    name="telefone"
                    label="Telefone para contato (com DDD)"
                    required
                    options={{
                        phone: true,
                        phoneRegionCode: 'BR',
                    }}
                />
            </Grid>

            <Grid item xs={12} sm={6}>
                <FormField
                    name="senha"
                    label="Senha"
                    hiddenPassword
                    required
                    autoComplete="off"
                />
            </Grid>

            <Grid item xs={12} sm={6}>
                <FormField
                    name="confirme"
                    label="Confirme sua senha"
                    hiddenPassword
                    required
                    autoComplete="off"
                />
            </Grid>

            {!representante && (
                <Fragment>
                    <Grid item xs={6}>
                        <SelectFunction required />
                    </Grid>

                    <Grid item xs={6}>
                        <SelectColaboradores required />
                    </Grid>

                    <Grid item xs={12}>
                        <AutocompleteSegmento />
                    </Grid>
                </Fragment>
            )}
        </Grid>
    )
}
